module.exports = "https://trybtryb-legacy.web.app/img/smile-and-wave.8d0e3c2d.webp";